module.exports = __webpack_public_path__ + "img/Slider2.80a95bca.svg";